import { useMemo } from 'react';
import { exceedsMaxValue, hasMaxLength, isInteger, isNotEmpty, isNotEmptyRTE, isNotNegative, isNotZero, isSelected, isValidLatitude, isValidLongitude, isValidRadius, } from '../../../hooks/formValidator/validators';
import { APP_LANGUAGES } from '../../../app.config.vars/languages';
export const buildInputValidationSchema = (taskType, saveAsDraft, formType, checkDescriptionTranslations) => {
    const baseSchema = {
        successPoints: [isInteger, isNotNegative, exceedsMaxValue(100)],
        failurePoints: [isInteger, isNotNegative, exceedsMaxValue(100)],
    };
    if (!saveAsDraft) {
        APP_LANGUAGES.forEach(({ code }) => {
            baseSchema[`title${code.toUpperCase()}`] = [isNotEmpty, hasMaxLength(250)];
            baseSchema[`description${code.toUpperCase()}`] = checkDescriptionTranslations
                ? [isNotEmptyRTE]
                : [];
        });
    }
    if (taskType === 'location') {
        baseSchema['coordinatesLat'] = [
            isNotEmpty,
            isValidLatitude,
            ...(saveAsDraft ? [] : formType === 'create' ? [isNotZero] : []),
        ];
        baseSchema['coordinatesLon'] = [
            isNotEmpty,
            isValidLongitude,
            ...(saveAsDraft ? [] : formType === 'create' ? [isNotZero] : []),
        ];
        baseSchema['radius'] = [
            isNotEmpty,
            isValidRadius,
            ...(saveAsDraft ? [] : formType === 'create' ? [isNotZero] : []),
        ];
    }
    return baseSchema;
};
const useTaskFormValidationSchema = ({ taskType, saveAsDraft }) => {
    const selectsValidationSchema = {
        taskType: [isSelected('single')],
    };
    const inputsValidationSchema = useMemo(() => buildInputValidationSchema(taskType, saveAsDraft), [taskType, saveAsDraft]);
    return { selectsValidationSchema, inputsValidationSchema };
};
export default useTaskFormValidationSchema;
